import { Libraries, LoadScript } from '@react-google-maps/api';
import { PermissionProvider } from 'PermissionContext';
import React from 'react';
import { Navigate, BrowserRouter as Router } from 'react-router-dom';
import { NavigationProvider } from '../../context/NavigationContext';
import AdminAppRoutes from './adminApp/AdminAppRoutes';
import {
  CheckLoginComponent,
  CheckLoginComponentWithKey,
  CheckLoginComponentWithKeyAndLayout,
} from './adminApp/CheckLoginComponent';
import CreateOppModalWithPermissions from './adminApp/CreateOppModalWithPermissions';
import { useCreateOpportunity } from './adminApp/useCreateOpportunity';

const GOOGLE_MAPS_LIBRARIES: Libraries = ['places'];

export { CheckLoginComponent, CheckLoginComponentWithKey, CheckLoginComponentWithKeyAndLayout };

export default function App() {
  const {
    showCreateOppModal,
    newOppName,
    newOppSummaryTitle,
    newOppNameError,
    newOppSummaryTitleError,
    oppNavigate,
    createOpportunity,
    submitNewOpp,
    setShowCreateOppModal,
    setNewOppName,
    setNewOppSummaryTitle,
    setOppNavigate,
  } = useCreateOpportunity();

  const googleMapsKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!;

  return (
    <LoadScript googleMapsApiKey={googleMapsKey} libraries={GOOGLE_MAPS_LIBRARIES}>
      <Router>
        <NavigationProvider>
          <AdminAppRoutes createOpportunity={createOpportunity} setOppNavigate={setOppNavigate} />
          {oppNavigate && <Navigate key={oppNavigate} to={oppNavigate} />}
          <CheckLoginComponent>
            <PermissionProvider>
              <CreateOppModalWithPermissions
                showCreateOppModal={showCreateOppModal}
                newOppName={newOppName}
                newOppSummaryTitle={newOppSummaryTitle}
                newOppNameError={newOppNameError}
                newOppSummaryTitleError={newOppSummaryTitleError}
                submitNewOpp={submitNewOpp}
                setShowCreateOppModal={setShowCreateOppModal}
                setNewOppName={setNewOppName}
                setNewOppSummaryTitle={setNewOppSummaryTitle}
              />
            </PermissionProvider>
          </CheckLoginComponent>
        </NavigationProvider>
      </Router>
    </LoadScript>
  );
}
